import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";

/**
 * URL 操作模块
 * @module url
 */
import qs from 'query-string';
var $isServer = typeof window === 'undefined';

function removeHash(url) {
  var index = url.indexOf('#');
  return index > -1 ? url.slice(0, index) : url;
}

function getHash(url) {
  var index = url.indexOf('#');
  return index > -1 ? url.slice(index) : '';
}
/**
 * 获取单个查询参数
 * @method getParam
 * @param  {String} key 所需的字段
 * @param  {String} [url=location.search] 完整的 `url` 链接或 `location.search` 格式的字段
 * @return {String|null} 参数的值
 */


export function getParam(key, url) {
  if ($isServer && !url) return;
  var search = url ? qs.extract(removeHash(url)) : location.search;
  return qs.parse(search)[key];
}
/**
 * 获取所有查询参数
 * @method getParams
 * @param  {String} [url=location.search] 完整的 `url` 链接或 `location.search` 格式的字段
 * @return {Object} 参数的键值对
 */

export function getParams(url) {
  if ($isServer && !url) return;
  var search = url ? qs.extract(removeHash(url)) : location.search;
  return qs.parse(search);
}
/**
 * 设置一个或多个查询参数
 * @method setParams
 * @param  {Object} obj 设置的字段集合
 * @param  {String|Number} [obj.[key]] 设置的字段
 * @param  {String} [url=location.href] 完整的 `url` 链接或 `location.search` 格式的字段
 * @return {String|Boolean} 基于 url 修改后的链接
 */

export function setParams(query, url) {
  if ($isServer && !url) return;
  if (!url) url = location.href;
  var path = removeHash(url).split('?')[0];
  var search = qs.extract(removeHash(url));
  var hash = getHash(url);
  var queryObject = Object.assign(qs.parse(search), query);
  var queryString = qs.stringify(queryObject);

  if (queryString) {
    queryString = '?' + queryString;
  }

  return "".concat(path).concat(queryString).concat(hash);
}
/**
 * 获取单个 hash 路由中的参数
 * @method getHashParam
 * @param  {String} key 所需的字段
 * @param  {String} [url=location.hash] 完整的 `url` 链接或 `location.hash` 格式的字段
 * @return {Object} 参数的值
 */

export function getHashParam(key, url) {
  if ($isServer && !url) return;
  var hash = url ? getHash(url) : location.hash;
  return hash ? getParam(key, hash.replace('#', '')) : undefined;
}
/**
 * 获取所有 hash 路由中的参数
 * @method getHashParams
 * @param  {String} [url=location.hash] 完整的 `url` 链接或 `location.hash` 格式的字段
 * @return {Object} 参数的键值对
 */

export function getHashParams(url) {
  if ($isServer && !url) return;
  var hash = url ? getHash(url) : location.hash;
  return hash ? getParams(hash.replace('#', '')) : {};
}
/**
 * 设置一个或多个 hash 路由参数
 * @method setHashParams
 * @param  {Object} obj 设置的字段集合
 * @param  {String|Number} [obj.[key]] 设置的字段
 * @param  {String} [url=location.href] 完整的 `url` 链接或 `location.hash` 格式的字段
 * @return {String|Boolean} 基于 url 修改后的链接
 */

export function setHashParams(query, url) {
  if ($isServer && !url) return;
  if (!url) url = location.href;
  var path = removeHash(url);
  var hash = getHash(url);
  if (!hash) return url;
  hash = setParams(query, hash.replace('#', ''));
  return "".concat(path, "#").concat(hash);
}
export default {
  getParam: getParam,
  getParams: getParams,
  setParams: setParams,
  getHashParam: getHashParam,
  getHashParams: getHashParams,
  setHashParams: setHashParams
};